import { LinearProgress, LinearProgressProps } from '@mui/material';

const LinearProgressComponent: React.FC<LinearProgressProps> = props => {
  return <LinearProgress {...props} />;
};

export default LinearProgressComponent;
